import checkContract from './checkContract';
import checkStaging from './checkStaging';
import checkRegisterStep from './checkRegisterStep';
import checkFeatureFlags from './checkFeatureFlags';

export default [
  checkContract,
  checkStaging,
  checkRegisterStep,
  checkFeatureFlags,
];
